import React, {useCallback, useContext, useEffect, useReducer, useState} from 'react';
import clsx from "clsx";
import {Button, Card, CardActions, CardContent, CardHeader, MenuItem, Tooltip, Typography} from "@mui/material";
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import {useForm} from "react-hook-form";
import Grid from "@mui/material/Grid";
import CustomDateInput from "../../../widgets/inputs/CustomDateInput";
import {valueRegister} from "../../../../utils/RegisterUtils";
import CustomMultiText from "../../../widgets/inputs/CustomMultiText";
import {prenotaTampone} from "../../../../services/TamponiServices";
import {initTamponiState, TAMPONI_INITIAL_STATE, TamponiReducer} from "../../../../reducers/TamponiReducer";
import {AnagraficaContext, AppContext} from "../../../../App";
import {setOpenSnackbar} from "../../../../services/AppServices";
import CustomSelect from "../../../widgets/inputs/CustomSelect";
import {addDayToDate} from "../../../../utils/GenericUtils";

const PrenotaTamponeCard = ({idSoggetto, setUpdateDiario, idQuarantena}) => {
	const classes = BaseStyle();
	const {reset, handleSubmit, control, errors, register} = useForm({mode: "onChange"});
	const [state, dispatch] = useReducer(TamponiReducer, TAMPONI_INITIAL_STATE, initTamponiState);
	const [submit, setSubmit] = useState(false);
	const appContext = useContext(AppContext);
	const anagraficaContext = useContext(AnagraficaContext);
	
	const onSubmit = useCallback((data) => {
		setSubmit(true);
		prenotaTampone({
			...data,
			motivazione: data.motivazione === "Normale" ? null : data.motivazione,
			quarantenaId: idQuarantena,
			soggetto: {
				idSoggetto: idSoggetto
			}
		}, dispatch)
	}, [idSoggetto, dispatch, idQuarantena]);
	
	useEffect(() => {
		if (submit && !state.loadingPrenotaTampone && state.errorPrenotaTampone === "") {
			setSubmit(false);
			reset({});
			if (setUpdateDiario) {
				setUpdateDiario(prevState => ++prevState);
			}
			setOpenSnackbar("success", "La richiesta è stata inoltrata all'ufficio tamponi, verrà gestita quanto prima!", appContext.dispatch);
		} else if (submit && !state.loadingPrenotaTampone && state.errorPrenotaTampone !== "") {
			setSubmit(false)
			setOpenSnackbar("error", state.errorPrenotaTampone, appContext.dispatch);
		}
	}, [submit, state.loadingPrenotaTampone, state.errorPrenotaTampone, appContext.dispatch, idSoggetto,
		anagraficaContext.dispatch, reset, setUpdateDiario])
	
	return (
		<React.Fragment>
			<Card className={clsx(classes.roundBorder)}
			      style={{display: "flex", flexDirection: "column"}}>
				<CardHeader
					title={<Typography variant={"h6"}><b>Richiesta prenotazione esame</b></Typography>}
					subheader={"Seleziona una data ed un luogo per la prenotazione di un esame e verificane la disponibilità."}
				/>
				<CardContent style={{flexGrow: 1}}>
					<form onSubmit={handleSubmit(onSubmit)}>
						<Grid container spacing={3}>
							<Grid item xs={12} sm={4}>
								<CustomDateInput
									name={"dataRichiesta"}
									label={"Data richiesta"}
									control={control}
									defaultValue={null}
									minDate={(new Date().getHours() <= 14) ? new Date() : addDayToDate(new Date(), 2)}
									rules={{required: true}}
									error={errors["dataRichiesta"]}
								/>
							</Grid>
							<Grid item xs={12} sm={8}>
								<CustomSelect
									control={control}
									rules={valueRegister}
									name={"luogo"}
									label={"Luogo prenotazione"}
									autoFocus={false}
									none={true}
									defaultValue={""}
									noneValue={""}
									error={errors["luogo"]}
								>
									<MenuItem value={"Hotspot"}>
										Hotspot
									</MenuItem>
									<MenuItem value={"Domicilio"}>
										Domicilio
									</MenuItem>
								</CustomSelect>
							</Grid>
							<Grid item xs={12} sm={6}>
								<CustomSelect
									control={control}
									rules={valueRegister}
									name={"motivazione"}
									label={"Priorità"}
									autoFocus={false}
									none={true}
									defaultValue={"Normale"}
									noneValue={""}
									error={errors["motivazione"]}
								>
									<MenuItem value={"Normale"}>
										Normale (verrà comunque gestita)
									</MenuItem>
									<MenuItem value={"Prioritaria"}>
										Prioritaria (verrà gestita con priorità)
									</MenuItem>
								</CustomSelect>
							</Grid>
							<Grid item xs={12} sm={6}>
								<CustomSelect
									control={control}
									rules={{required: true}}
									name={"criterioEpidemiologico"}
									label={"Tipologia tampone"}
									autoFocus={false}
									none={true}
									defaultValue={"TC"}
									noneValue={""}
									error={errors["criterioEpidemiologico"]}
								>
									<MenuItem value={"TC"}>
										Tampone di controllo
									</MenuItem>
									<MenuItem value={"TD"}>
										Tampone di diagnosi
									</MenuItem>
								</CustomSelect>
							</Grid>
							<Grid item xs={12}>
								<CustomMultiText
									inputRef={register({required: false})}
									name={"note"}
									label={"Note da indicare al gruppo tamponi"}
									autoFocus={false}
									error={errors["note"]}
									rows={5}
								/>
							</Grid>
							
							{/*<Grid item xs={12}>
							 <CustomSelect
							 control={control}
							 rules={valueRegisterNone}
							 name={"criterioEpidemiologico"}
							 label={"Criterio epidemiologico"}
							 autoFocus={false}
							 defaultValue={""}
							 none={true}
							 noneValue={""}
							 error={errors["criterioEpidemiologico"]}
							 >
							 {criteri.map((val, key) => {
							 return (
							 <MenuItem value={val} key={key}>
							 {val}
							 </MenuItem>
							 );
							 })}
							 </CustomSelect>
							 </Grid>
							 <Grid item xs={12}>
							 <CustomSelect
							 control={control}
							 rules={valueRegisterNone}
							 name={"motivazione"}
							 label={"Motivazione"}
							 autoFocus={false}
							 none={true}
							 defaultValue={""}
							 noneValue={""}
							 error={errors["motivazione"]}
							 >
							 {motivazioni.map((val, key) => {
							 return (
							 <MenuItem value={val} key={key}>
							 {val}
							 </MenuItem>
							 );
							 })}
							 </CustomSelect>
							 </Grid>
							 <Grid item xs={12} sm={6}>
							 <CustomText
							 control={control}
							 rules={{required: false}}
							 name={"medicoRichiedente"}
							 label={"Medico richiedente"}
							 autoFocus={false}
							 type={"text"}
							 error={errors["medicoRichiedente"]}
							 />
							 </Grid>
							 <Grid item xs={12} sm={6}>
							 <CustomText
							 control={control}
							 rules={{required: false}}
							 name={"contattoRichiedente"}
							 label={"Contatto richiedente"}
							 autoFocus={false}
							 type={"text"}
							 error={errors["contattoRichiedente"]}
							 />
							 </Grid>*/}
						</Grid>
					</form>
				</CardContent>
				<CardActions className={classes.flexRight}>
					<Tooltip title={"Conferma prenotazione tampone"}>
						<Button size={"small"} variant={"contained"} color={"primary"} disableElevation disabled={submit}
						        style={{borderRadius: 24}}
						        className={classes.roundButton} onClick={handleSubmit(onSubmit)}>
							<b>Prenota</b>
						</Button>
					</Tooltip>
				</CardActions>
			</Card>
		</React.Fragment>
	);
};

export default React.memo(PrenotaTamponeCard);
